export default {
    name: 'SquareFill',
    dimensions: { width: 20, height: 20 },
    content: `
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3 0C1.34772 0 0 1.34772 0 3V17C0 18.6523 1.34772 20 3 20H17C18.6523 20 20 18.6523 20 17V3C20 1.34772 18.6523 0 17 0H3Z" fill="currentColor"/>
  `
};

